<template>
    <div class="bg-[#23242A] text-white h-screen appheader overflow-y-auto p-5">
        <div class="grid grid-cols-1">

            <template v-if="vg_selectedLocation.id">
              <div class="bg-[#2B2C32] rounded-lg px-8 py-[16px]" v-if="loading">
                <block-loading />
              </div>
              <div class="bg-[#2B2C32] rounded-lg px-8 mt-1 py-[16px]" v-else>
                <div class=" flex justify-between items-center pt-2 mb-8">
                    <h1 class="text-white font-semibold text-[24px]">Message Banner</h1>
                    <button @click.prevent="save()" :disabled="!form.headerTitle.value || !form.headerMessage.value || !validLength" class="bg-white text-theme-green rounded  mt-2 px-4 py-2 hover:bg-theme-darkgreen hover:text-white disabled:bg-theme-grey disabled:text-grey"><span class="text-sm tracking-widest font-medium">SAVE</span></button>
                </div>
                <div class="flex gap-3 flex-col items-start mb-3">
                    <div class="w-full">
                       <label class="flex items-center cursor-pointer w-[100px]">
                        <input type="checkbox" v-model="form.displayHeaderMessage" class="hidden peer">
                        <div :class="'relative toggle-bg  border-2  h-6 w-11 rounded-full ' + (form.displayHeaderMessage ? 'bg-theme-green border-theme-green' : 'bg-[#F53333] border-[#F53333]')"></div>
                        <span class="ml-2 text-white text-sm font-medium uppercase" :class="form.displayHeaderMessage ? 'text-theme-green' : 'text-[#F53333]'">{{form.displayHeaderMessage ? 'ON' : 'OFF'}}</span>
                      </label>
                    </div>
                    <div class="w-full">
                        <div :class="'input-wrapper ' + (form.headerTitle.error_type)">
                            <label class="text-xs mb-1 font-normal">Header</label>
                            <input placeholder="" maxlength="100" @keyup="validateFields(['headerTitle'])" v-model="form.headerTitle.value" type="text" class="block rounded bg-gray-black border-none w-full text-sm text-theme-white">
                            <p class="field-error label-text mt-1" v-if="form.headerTitle.error_message" v-text="form.headerTitle.error_message"></p>
                        </div>
                    </div>

                    <div class="w-full">
                        <div :class="'input-wrapper' + (form.headerMessage.error_type)">
                            <label class="text-xs mb-1 font-normal">Body</label>
                     
                            <editor
                              v-model="form.headerMessage.value"
                              api-key="g9cb9qbrbpojjpn14jkz7wzm70e222rsiaov5xfa0170aerh"
                              :init="{
                                menubar: false,
                                plugins: 'lists link wordcount',
                                toolbar: 'styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist | link image emoticons',
                                skin: 'oxide-dark',
                                content_css: 'dark',
                              }"
                              @keyup="editorChange"
                            />
                         
                            <p class="field-error label-text mt-1" v-if="form.headerMessage.error_message" v-text="form.headerMessage.error_message"></p>
                          </div>
                      </div>
                  </div>
              </div>
            </template>

          
            <div class="bg-[#2B2C32] rounded-lg px-8 py-[16px]" v-else>
              <p  class="text-center text-theme-red">Please select a location from the top left corner.</p>
            </div>
          
            
        </div>
    </div>
</template>

<script lang="ts">
import  { defineComponent , ref} from "vue";
import { mapGetters, mapActions, mapMutations } from "vuex";
import { useSnackbar } from "vue3-snackbar";
import Editor from '@tinymce/tinymce-vue'
import LocationBannerMessageApis from '@/controllers/LocationBannerMessageApis';
import Helpers from '@/helpers';

export default defineComponent({
  name: "MessageBanner",
  components: {
    'editor': Editor
  },

  setup() {
    const snackbar = useSnackbar();
    const hasRecord = ref(false);
    const loading = ref(false);
    const editorMaxLen = 1500
    const validLength = ref(false)
    const form:any = ref({
      displayHeaderMessage: false,
      headerTitle: {
          value: '',
          error_type: '',
          error_message: '',
          validations: [],
      },
      headerMessage: {
          value: '',
          error_type: '',
          error_message: '',
          validations: [],
      },
    });
    return  {
      snackbar,
      editorMaxLen,
      validLength,
      form,
      hasRecord,
      loading
    };
  },

  watch : {
    'vg_selectedLocation'(val) {
      // if location selected clear component
      this.fetchLocationMessageBanner();
    },
    'form.displayHeaderMessage'(val) {
      if(val) {
        this.form.headerTitle.validations = ['required', 'min:3']
        this.form.headerMessage.validations = ['required']
      }  else {
        this.form.headerTitle.validations = []
        this.form.headerTitle.error_type = ''
        this.form.headerTitle.error_message = ''
        this.form.headerMessage.validations = []
        this.form.headerMessage.error_type = ''
        this.form.headerMessage.error_message = ''
      }
    }
  },

  computed: {
    ...mapGetters({
        vg_selectedLocation: 'location/selected'
    }),
  },

  async mounted() {
    this.loading = true;
    await this.fetchLocationMessageBanner();
    this.loading = false;
  },

  methods: {
    editorChange(e, editor){
      this.validLength = false
      let characterCount = editor.plugins.wordcount.body.getCharacterCount()
      if(characterCount>this.editorMaxLen){
        this.validLength = false
        this.form.headerMessage.error_type = 'error'
        this.form.headerMessage.error_message = `Must be less than ${this.editorMaxLen} characters!`
      }else if(characterCount===0){
        this.validLength = false
        this.form.headerMessage.error_type = ''
        this.form.headerMessage.error_message = ''
      }else{
        this.validLength = true
        this.form.headerMessage.error_type = ''
        this.form.headerMessage.error_message = ''
      }
      
    },
    /**
   * Fetch banner message
   */
    async fetchLocationMessageBanner() {
      let res = await LocationBannerMessageApis.fetchLocationBannerMessage();
      if(res.status == 200) {
        this.hasRecord = true;
        this.form.displayHeaderMessage = res.data.payload.displayHeaderMessage;
        this.form.headerTitle.value = res.data.payload.headerTitle;
        this.form.headerMessage.value = res.data.payload.headerMessage;
      } else {
        this.hasRecord = false;
        this.form.displayHeaderMessage = false;
        this.form.headerTitle.value = '';
        this.form.headerMessage.value = '';
      }
    },

    /**
     * Create location message
     */
    async create() {
      this.va_spinner(true);
      let res = await LocationBannerMessageApis.createLocationBannerMessage(Helpers.getFormKeyValue(this.form))
      this.va_spinner(false);
      if(res.status == 201){
        this.hasRecord = true;
      }
      this.snackbar.add({
        type: 'info',
        text: res.status == 201 ? res.data.message : Helpers.catchErrorMessage(res.response.data),
        duration: 3000,
      })
    },

    /**
   * Update location message
   */
    async update() {
      this.va_spinner(true);
      let res = await LocationBannerMessageApis.updateLocationBannerMessage(Helpers.getFormKeyValue(this.form))
      this.va_spinner(false);
      this.snackbar.add({
        type: 'info',
        text: res.status == 200 ? res.data.message : Helpers.catchErrorMessage(res.response.data),
        duration: 3000,
      })
    },

    /**
     * Validation captures
     */
    async validateFields(fields) {
      let res = await Helpers.validateFormFields(this.form, fields);
      // capture the fields
      this.form = res.data;
      return res.error ? false : true;
    },

    /**
     * Save
     */
    async save() {
      // validate business field
      let validate = await this.validateFields(['headerTitle', 'headerMessage']);
      if(!validate) {
        return ;
      }
      if( this.hasRecord ) {
        this.update()
      } else {
        this.create();
      }
    },
   
    ...mapActions({
      va_spinner: "spinner/setSpinner",
    })

  }
});
</script>

